<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'AvContractQualityControlForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    avContract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'avContract',
    };
  },
};
</script>

<template>
  <div class="avContract-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md12 xs12>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.isQsUnknown')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isQsUnknown"
              label="Unbekannt"
              class="caption"
              hide-details
            />
          </v-flex>
        </v-layout>
        <!-- eslint-disable -->
        <v-layout row wrap>
          <v-flex v-if="isFieldVisible('avContract.isDpcRequested') && avContract.isQsUnknown != 1 && avContract.isDpcRequestNotObliged != 1 && avContract.hasContactPerson != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isDpcRequested"
              label="Schriftliche Bestellung eines Datenschutzbeauftragten, der seine Tätigkeit gemäß Art. 38 und 39 DS-GVO ausübt."
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.areDpcCredsSubmitted') && avContract.isDpcRequested == 1 && avContract.isQsUnknown != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.areDpcCredsSubmitted"
              label="Dessen Kontaktdaten werden dem Auftraggeber zum Zweck der direkten Kontaktaufnahme mitgeteilt. Ein Wechsel des Datenschutzbeauftragten wird dem Auftraggeber unverzüglich mitgeteilt."
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.areDpcCredsAccessible') && avContract.isDpcRequested == 1 && avContract.isQsUnknown != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.areDpcCredsAccessible"
              label="Dessen jeweils aktuelle Kontaktdaten sind auf der Homepage des Auftragnehmers leicht zugänglich hinterlegt"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.isDpcRequestNotObliged') && avContract.isQsUnknown != 1 && avContract.isDpcRequested != 1 && avContract.hasContactPerson != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.isDpcRequestNotObliged"
              label="Der Auftragnehmer ist nicht zur Bestellung eines Datenschutzbeauftragten verpflichtet."
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasContactPerson') && avContract.isQsUnknown != 1 && avContract.isDpcRequested != 1 && avContract.isDpcRequestNotObliged != 1" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasContactPerson"
              label="Da der Auftragnehmer seinen Sitz außerhalb der Union hat, benennt er folgenden Vertreter nach Art. 27 Abs. 1 DS-GVO in der Union"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.contactPerson') && avContract.hasContactPerson == 1" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.contactPerson"
              label="Ansprechpartner"
              class="caption"
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.hasOtherObligations')" xs12 md6 py-0>
            <v-checkbox
              v-model="avContract.hasOtherObligations"
              label="Sonstiges Qualitätssicherungen und Pflichten"
              class="caption"
              hide-details
            />
          </v-flex>

        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('avContract.otherObligations') && avContract.hasOtherObligations == 1" xs12 md6 py-0>
            <v-textarea
              v-model="avContract.otherObligations"
              label="Text Qualitätssicherungen und Pflichten"
              class="caption"
            />
          </v-flex>
        </v-layout>
        <!-- eslint-enable -->
      </v-flex>
    </v-layout>
  </div>
</template>
